// @flow
import { Component } from "react";

export default class RedirectoIndex extends Component<*> {
  componentDidMount() {
    window.location = "/account/profile";
  }
  render(): * {
    return null;
  }
}
